import {FetchBaseQueryError} from '@reduxjs/toolkit/query';
import {FormSubmitHandler} from 'platform/components';

import {omit} from 'ramda';

import {useCreateConsentTypeMutation} from '@dms/api/customer';
import {CreateConsentTypeRequestBody, CreateTemplateRequestBody} from '@dms/api/shared';
import i18n from '@dms/i18n';
import {handleApiError} from '@dms/shared';

import {useNavigate} from 'shared/web';

import {ConsentTypeFormType} from '../../../components/GdprConsentTypeForm/components/ConsentTypeFormTemplate';
import {GdprConsentTypeForm} from '../../../components/GdprConsentTypeForm/GdprConsentTypeForm';
import {getConsentTypeRecipientFields} from '../../../utils/getConsentTypeRecipientFields';

interface AddGdprConsentTypeFormProps {
  cancelRoute: string;
}

export function AddGdprConsentTypeForm(props: AddGdprConsentTypeFormProps) {
  const navigate = useNavigate();
  const [create] = useCreateConsentTypeMutation();

  const onSubmit: FormSubmitHandler<ConsentTypeFormType> = async (
    values,
    setErrors,
    _reset,
    blockerContext
  ) => {
    const templates = values.templates.map(
      omit(['fileUri', 'fileName'])
    ) as CreateTemplateRequestBody[];

    const body: CreateConsentTypeRequestBody = {
      ...values,
      name: values.name.trim(),
      templates,
      ...getConsentTypeRecipientFields(values),
    };

    await create({createConsentTypeRequestBody: body})
      .unwrap()
      .then(() => {
        if (blockerContext?.wasSubmittedFromBlocker) {
          return;
        }
        navigate(props.cancelRoute);
      })
      .catch((error: FetchBaseQueryError) =>
        handleApiError(error, {
          silentOnValidationError: true,
          setErrors,
          signalApiError: blockerContext?.reportApiFailure,
        })
      );
  };

  return (
    <GdprConsentTypeForm
      onSubmit={onSubmit}
      cancelRoute={props.cancelRoute}
      defaultValues={{branchId: null, recipientCustomerId: null, templates: []}}
      submitTitle={i18n.t('general.actions.create')}
    />
  );
}
